import React, { useState, useEffect, useContext } from "react";
import MainInputSection from "./MainInput";
import ss from "../../assets/json/city";
import CustomerInfoForm from "./form";
import { Wrapper } from "./../UI/mainPage";
import Dial from "./dial";
import GetCity from "./getCity";
import lstool from "../../utils/localStorage";
import fetchModule from "../../utils/fetchingData";
import { createSendForm } from "../../utils/form";
import API from "./../../configs/API";
import { toast } from "react-toastify";
import { css } from "styled-components/macro";
import { ModalContext } from "./../general/ModalContext";
import { Loading } from "../UI/general";
export default function Main(props) {
  const setModal = useContext(ModalContext);
  let [isLoadingGetNumber, SetLoadingGetNumber] = useState(false);
  let [Phone, setPhone] = useState("");
  let [Name, setName] = useState("");
  let [city, setCity] = useState(null);
  let [ShouldShowButtons, SetShouldShowButtons] = useState(false);
  const GetNumber = async () => {
    SetLoadingGetNumber(true);
    let response = await fetchModule.post(
      "",
      createSendForm(
        {
          type: API.getNumber,
          shahrestanid: JSON.parse(lstool.get("chosenCity")).value,
          userid: lstool.get()
        },
        false,
        "multiPart"
      )
    );
    SetLoadingGetNumber(false);
    const accessToImport = JSON.parse(lstool.get("userData")).AccessToImport;
    if (response) {
      if (accessToImport !== "true") {
        lstool.set("autoGenerate", true);
      }
      SetShouldShowButtons(true);
      const data = response.split("-");
      setPhone(data[0]);
      setName(data[1] || "");
    } else {
      lstool.set("autoGenerate", false);
      setPhone(-1);
    }
  };
  const ReStatusFunction = str => {
    SetShouldShowButtons(true);
    setPhone(str);
    lstool.remove("ReStatusNumber");
  };
  const AutoGenerate = () => {
    const ReStatus = lstool.get("ReStatusNumber");
    const accessToImport = JSON.parse(lstool.get("userData")).AccessToImport;
    if (
      lstool.get("autoGenerate") == "true" &&
      !ReStatus &&
      accessToImport !== "true"
    ) {
      GetNumber();
    } else if (ReStatus) {
      ReStatusFunction(ReStatus);
    }
  };
  const ImportingPhoneNumber = async (number, isRandom) => {
    setPhone(String(number));
    setName("");
    if (!isRandom) {
      if (number.length === 11) {
        setModal(Loading);
        let response = await fetchModule.post(
          "",
          createSendForm(
            {
              type: API.insertNumber,
              shahrestanid: JSON.parse(lstool.get("chosenCity")).value,
              shahrestanname: city.label,
              userid: lstool.get(),
              mainmobilenumber: number
            },
            false,
            "multiPart"
          )
        );
        setModal(null);
        if (response == "شماره مورد نظر مورد تایید نمی باشد") {
          toast.warn("این شماره قبلا ثبت شده!");
          setPhone("");
        } else {
          SetShouldShowButtons(true);
        }
      } else {
        SetShouldShowButtons(false);
      }
    }
  };

  const setStatus = async (status, hours) => {
    const accessToImport = JSON.parse(lstool.get("userData")).AccessToImport;
    switch (status) {
      case 1:
        props.history.push("/form", { city, Phone, Name, status });
        break;
      case 3:
        setModal(Loading);
        let FollowUpResponse = await fetchModule.post(
          "",
          createSendForm(
            {
              type: API.setFollowUpStatus,
              userid: lstool.get(),
              mainmobilenumber: Phone,
              reminderhours: hours
            },
            false,
            "multiPart"
          )
        );
        setModal(null);
        SetShouldShowButtons(false);
        if (accessToImport !== "true") {
          GetNumber();
        } else {
          setPhone("");
        }
        break;
      default:
        setModal(Loading);
        let response = await fetchModule.post(
          "",
          createSendForm(
            {
              type: API.setStautsAPI,
              userid: lstool.get(),
              mainmobilenumber: Phone,
              condition: status
            },
            false,
            "multiPart"
          )
        );
        setModal(null);
        SetShouldShowButtons(false);
        if (accessToImport !== "true") {
          GetNumber();
        } else {
          setPhone("");
        }
        break;
    }
  };

  const CheckCity = val => {
    setCity(val);
  };
  return (
    <Wrapper
      css={css`
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: 15px;
      `}
    >
      <GetCity
        AutoGenerate={AutoGenerate}
        setCity={CheckCity}
        getNumber={GetNumber}
      ></GetCity>
      {city ? (
        <Dial
          isLoading={isLoadingGetNumber}
          val={Phone}
          setVal={ImportingPhoneNumber}
          getNumber={GetNumber}
          showButtons={ShouldShowButtons}
          name={Name}
          setStatus={setStatus}
        />
      ) : null}
    </Wrapper>
  );
}
// <Select
//   options={ss.map(item => ({ value: item.id, label: item.city }))}
// ></Select>
